import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import MenuItemsTable from './menuItemsTable';
import { connect } from 'react-redux';
import Pagination2 from '../../components/Pagination2';
import * as menuItemsActions from '../../redux/menuItems/actions';
import AddMenuItems from './modals/insertNewMenuItem';
import Spin from '../../components/loading';
import ShowForPermission from '../../components/ShowForPermission';
import ENUMS from '../../enums';
import AlertAndConfirmation from '../../utils/AlertAndConfirmation';
import MenuItemsFilter from './Filter';
import submitForm from '../../utils/submitForm';

class MenuItems extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      errorText: locales('errors.default'),
      errorFlag: false,
      itemsPerPage: 10,
      addMenuItemsOpen: false,
      selectedMenuItemId: null,
      sortType: 'asc',
      selectedCafeIds: [],
      selectedRegions: [],
      selectedAmenities: [],
    };
  }

  handleAlert = () => {
    AlertAndConfirmation({ text: this.state.errorText, type: 'error' });
    this.setState({ errorFlag: false });
  };

  applyFilters = (event, categoryIds) => {
    const queryString = submitForm(
      event,
      this.state.selectedRegions,
      this.state.selectedAmenities,
      this.state.selectedCafeIds,
      categoryIds,
    );
    this.setState({ filter: queryString }, () => this.filterAndSort());
  };

  sortTable = query => {
    this.setState(
      { sortType: this.state.sortType == 'asc' ? 'desc' : 'asc' },
      () => {
        query = `${query}-${this.state.sortType}`;
        this.setState({ sort: `sort=${query}` }, () => this.filterAndSort());
      },
    );
  };

  filterAndSort = () => {
    let { filter, sort } = this.state;
    let query;
    if (sort && filter) query = `${filter}&${sort}`;
    else if (filter) query = `${filter}`;
    else if (sort) query = `${sort}`;
    this.setState({ query, currentPage: 1 }, () => {
      let searchQuery = this.buildSearchQuery(
        this.state.currentPage,
        this.state.itemsPerPage,
      );
      this.props.fetchAllMenuItems(searchQuery);
    });
  };

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  onPageChanged = data => {
    const { currentPage, totalPages, pageLimit } = data;
    
    this.setState({ currentPage: currentPage }, () => {
      const query = this.buildSearchQuery(
        this.state.currentPage,
        this.state.itemsPerPage,
      );
      this.props.fetchAllMenuItems(query);
    });
  };

  closeMenuItemsModal = () => {
    this.props
      .fetchAllMenuItems(
        `pageNumber=${this.state.currentPage}&pageSize=${this.state.itemsPerPage}`,
      )
      .then(() => {
        this.setState(() => ({
          addMenuItemsOpen: false,
        }));
      });
  };

  displayAddMenuItemsModal = () => {
    this.setState({ addMenuItemsOpen: true });
  };

  getAllCategories = () => {
    this.setState({ query: '' });
    const newQuery = `pageNumber=${this.state.currentPage}&pageSize=${this.state.itemsPerPage}`;
    this.props.fetchAllMenuItems(newQuery);
  };

  render() {
    let { loading, message, failed, error } = this.props;
    let { totalRecords } = this.props.menuItems;
    let { currentPage, itemsPerPage } = this.state;

    return (
      <>
        {this.state.errorFlag && this.handleAlert()}
        <div className='col-12 d-flex justify-content-between align-items-center'>
          <h3 className='text-right text-muted py-4'>
            <div className='text-right'>{locales('titles.cafeMenuItems')}</div>
          </h3>
          <div>
            <Link to='/menu-items-deleteds'>
              <button className='btn btn-secondary w-5 mx-1'>
                <i className='fa fa-times' />
                {locales('labels.deleteds')}
              </button>
            </Link>
            <ShowForPermission
              permission={ENUMS.PERMISSIONS.values.ADD_NEW_MENU_ITEM}
            >
              <button
                onClick={() => this.displayAddMenuItemsModal()}
                className='btn btn-primary w-5 mx-1'
              >
                <i className='fal fa-plus mx-1' />
                {locales('labels.new')}
              </button>
            </ShowForPermission>
          </div>
        </div>
        <section className='p-1 col-12'>
          <MenuItemsFilter
            applyFilters={this.applyFilters}
            getAllCategories={this.getAllCategories}
          />

          <Spin spinning={loading}>
            <article>
              <main className='panel panel-default'>
                {error ? (
                  <div className='alert alert-danger'>
                    {locales('messages.server.error')}
                  </div>
                ) : (
                  <>
                    {failed && (
                      <div className='alert alert-danger'>{message}</div>
                    )}
                    <div className='panel-heading'>
                      <i className='fas fa-list-alt px-1' />
                      {locales('titles.menuItems')}
                    </div>
                    <div className='panel-body'>
                      <div className='table-responsive'>
                        <MenuItemsTable
                          pageNumber={currentPage}
                          pageSize={itemsPerPage}
                        />
                      </div>
                      <footer className='col-12 d-flex justify-content-center py-2'>
                        <div className='pagination-container'>
                          <Pagination2
                            totalRecords={totalRecords || 0}
                            pageLimit={itemsPerPage}
                            pageNeighbours={2}
                            onPageChanged={this.onPageChanged}
                            currentPage={this.state.currentPage}
                          />
                        </div>
                      </footer>
                      {this.state.addMenuItemsOpen && (
                        <AddMenuItems
                          pageNumber={currentPage}
                          pageSize={1000}
                          isOpen={this.state.addMenuItemsOpen}
                          closeModal={this.closeMenuItemsModal}
                        />
                      )}
                    </div>
                  </>
                )}
              </main>
            </article>
          </Spin>
        </section>
      </>
    );
  }
}
const mapStateToProps = state => {
  return {
    cafeName: state.authReducer.meInfo.selectedRole.cafeName,
    loading: state.menuItemsReducer.menuItemsLoading,
    message: state.menuItemsReducer.menuItemsMessage,
    failed: state.menuItemsReducer.menuItemsFailed,
    error: state.menuItemsReducer.menuItemsError,
    menuItemsList: state.menuItemsReducer.menuItemsList,
    menuItems: state.menuItemsReducer.menuItems,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    fetchAllMenuItems: query =>
      dispatch(menuItemsActions.fetchAllMenuItems(query)),
  };
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MenuItems),
);
